import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pt-24 -md:pt-16" }
const _hoisted_2 = ["hidden"]
const _hoisted_3 = { class: "px-6 py-5" }
const _hoisted_4 = { class: "flex flex-col my-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "title text-left pb-5" }, "Filtrar histórico de repasse de comissões", -1)
const _hoisted_6 = { class: "flex h-full w-full flex-col items-center justify-start" }
const _hoisted_7 = { class: "grid grid-cols-12 gap-x-4 gap-y-2 -lg:flex -lg:flex-col" }
const _hoisted_8 = { class: "col-span-12 grid grid-cols-12 w-full gap-4 -lg:flex -lg:flex-col" }
const _hoisted_9 = { class: "col-span-4 flex h-full w-full items-center justify-end -lg:h-16" }
const _hoisted_10 = {
  key: 0,
  class: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8"
}
const _hoisted_11 = { class: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" }
const _hoisted_12 = { class: "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg p-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "title text-left pb-5" }, "Histórico de solicitações", -1)
const _hoisted_14 = {
  key: 1,
  class: "shadow overflow-hidden flex flex-col items-center justify-center border-b border-gray-200 bg-gray-50 sm:rounded-lg w-full h-max-screen"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("embed", {
  width: "75",
  height: "75",
  src: "/colorful-loading.gif",
  class: "m-auto"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "my-1 text-xs" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Carregando...")
], -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "w-1/2 bg-white m-auto rounded-lg p-3 z-50" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "text-black text-2xl" }, " Solicitação de repasse de comissão ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "my-3 text-base" }, "Você deseja aprovar ou rejeitar a solicitação?", -1)
const _hoisted_21 = { class: "flex items-center mt-4 h-full w-full justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Table = _resolveComponent("Table")!
  const _component_TextArea = _resolveComponent("TextArea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "toast-block",
      hidden: _ctx.hidden,
      onHide: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.hide()), ["self"]))
    }, [
      _createVNode(_component_Toast, {
        label: _ctx.message,
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.hide()), ["self"])),
        success: _ctx.toastSuccess,
        onHide: _ctx.hide
      }, null, 8, ["label", "success", "onHide"])
    ], 40, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Form, { class: "mt-1 !space-y-0" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_Input, {
                      modelValue: _ctx.protocolFilter,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.protocolFilter) = $event)),
                      label: "Protocolo",
                      class: "col-span-4",
                      isIncorrect: !!_ctx.errorMessage,
                      incorrectMessage: _ctx.errorMessage
                    }, null, 8, ["modelValue", "isIncorrect", "incorrectMessage"]),
                    _createVNode(_component_Input, {
                      modelValue: _ctx.softwareHouseFilter,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.softwareHouseFilter) = $event)),
                      label: "CNPJ da Software House",
                      class: "col-span-4",
                      isIncorrect: !!_ctx.errorMessage,
                      incorrectMessage: _ctx.errorMessage
                    }, null, 8, ["modelValue", "isIncorrect", "incorrectMessage"]),
                    (_openBlock(), _createBlock(_component_Select, {
                      label: "Situação",
                      options: () => _ctx.commissionRequestStatusOptions,
                      key: _ctx.selectedCommissionRequestStatus.key,
                      selected: _ctx.selectedCommissionRequestStatus.value,
                      display: "value",
                      class: "col-span-4",
                      event: "update:select",
                      "onUpdate:select": _ctx.handleCommissionProtocolStatus
                    }, null, 8, ["options", "selected", "onUpdate:select"])),
                    _createVNode(_component_Input, {
                      modelValue: _ctx.startFilter,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.startFilter) = $event)),
                      type: "date",
                      label: "Solicitado de",
                      class: "col-span-4",
                      isIncorrect: !!_ctx.errorMessage,
                      incorrectMessage: _ctx.errorMessage
                    }, null, 8, ["modelValue", "isIncorrect", "incorrectMessage"]),
                    _createVNode(_component_Input, {
                      modelValue: _ctx.endFilter,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.endFilter) = $event)),
                      type: "date",
                      label: "Solicitado até",
                      class: "col-span-4",
                      isIncorrect: !!_ctx.errorMessage,
                      incorrectMessage: _ctx.errorMessage
                    }, null, 8, ["modelValue", "isIncorrect", "incorrectMessage"]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_PrimaryButton, {
                        label: "Filtrar",
                        type: "button",
                        icon: _ctx.buttonIcons.search.icon,
                        iconCustomClass: "text-white",
                        width: "w-full",
                        class: "col-span-12",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getCommissionRequests()))
                      }, null, 8, ["icon"])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          (!_ctx.commissionRequestsLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    (_openBlock(), _createBlock(_component_Table, {
                      columns: ['Protocolo', 'CNPJ da Software House', 'Situação', 'Período', 'Valor', 'Data de Recebimento', 'Data Solicitação'],
                      values: () => _ctx.commissionRequests.map(({ softwareHouse, startDate, value, endDate, protocol, status, createdAt, receiptDate }) => {
                    const startDateISO = _ctx.parseISODate(startDate);
                    const endDateISO = _ctx.parseISODate(endDate);

                    const startDateUTC = new Date(startDateISO.getTime() + (startDateISO.getTimezoneOffset() * 60000))
                    const endDateUTC = new Date(endDateISO.getTime() + (endDateISO.getTimezoneOffset() * 60000))
                    return {
                      protocol: protocol,
                      softwareHouseCnpj: _ctx.formatCnpj(softwareHouse.cnpj),
                      status: _ctx.commissionRequestStatus[status],
                      interval: `${_ctx.formatDate(startDateUTC, 'dd/MM/yyyy')} - ${_ctx.formatDate(endDateUTC, 'dd/MM/yyyy')}`,
                      value: Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value),
                      receiptDate: receiptDate ? _ctx.formatDate(_ctx.parseISODate(receiptDate), 'dd/MM/yyyy') : '-',
                      createdAt: _ctx.formatDate(_ctx.parseISODate(createdAt), 'dd/MM/yyyy')
                    }
                  }),
                      key: JSON.stringify(_ctx.commissionRequests),
                      tableId: "protocol",
                      optionsColumn: true,
                      itemsPerPage: 20,
                      buttons: ['edit'],
                      "onUpdate:editTableItem": _ctx.handleEdit
                    }, null, 8, ["values", "onUpdate:editTableItem"]))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
        ])
      ])
    ]),
    _createElementVNode("div", {
      id: "overlay",
      class: _normalizeClass(["fade-in", _ctx.approveOrRejectCommissionRequestModal ? 'block' : 'hidden fade-out'])
    }, [
      _createElementVNode("div", {
        class: "h-screen flex overflow-y-scroll p-8",
        onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.approveOrRejectCommissionRequestModal = false), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _hoisted_20,
          (_openBlock(), _createBlock(_component_Select, {
            label: "Nova Situação",
            options: () => _ctx.commissionRequestStatusAccepted,
            key: _ctx.selectedCommissionRequestStatusToUpdate.key,
            selected: _ctx.selectedCommissionRequestStatusToUpdate.value,
            display: "value",
            class: "mt-3 w-1/2 -lg:w-full",
            event: "update:select",
            "onUpdate:select": _ctx.handleCommissionRequestStatus
          }, null, 8, ["options", "selected", "onUpdate:select"])),
          (_ctx.selectedCommissionRequestStatusToUpdate.key === 'approved')
            ? (_openBlock(), _createBlock(_component_Input, {
                key: 0,
                modelValue: _ctx.commissionRequestForm.receiptDate,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.commissionRequestForm.receiptDate) = $event)),
                type: "date",
                label: "Data de recebimento",
                class: "mt-3"
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (_ctx.selectedCommissionRequestStatusToUpdate.key === 'rejected')
            ? (_openBlock(), _createBlock(_component_TextArea, {
                key: 1,
                modelValue: _ctx.commissionRequestForm.message,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.commissionRequestForm.message) = $event)),
                label: "Motivo da recusa",
                class: "mt-3"
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_PrimaryButton, {
              label: "Salvar",
              onClick: _ctx.updateCommissionRequest,
              disabled: _ctx.loading,
              iconCustomClass: "text-white",
              class: "ml-2",
              width: "w-48 -lg:w-full",
              type: "submit"
            }, null, 8, ["onClick", "disabled"])
          ])
        ])
      ])
    ], 2)
  ]))
}